import { XHeadCell } from '../../../../components/table/XTableHead';
import { Box, Chip, Typography } from '@mui/material';
import {  printDateTime } from '../../../../utils/dateHelpers';
import ContactLink from '../../../../components/links/ContactLink';
import { localRoutes } from '../../../../constants';
import { IColumn, InputType } from '../../../../components/dynamic-editor/types';
import React from 'react';
import CheckIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Cancel';
import { toTitleCase, trimString } from '../../../../utils/stringHelpers';
import { RequestStatus } from '../../../../__generated__/kycTypes';
import LoopIcon from '@mui/icons-material/Loop';
import PendingIcon from '@mui/icons-material/Pending';


export const peopleTemplatesQueryName = 'people-templates';

export const initialSort = 'created_date';

export const columns = (isRootUser: boolean): XHeadCell[] => {
  return [
    {
      name: 'createdAt',
      label: 'CREATED ON',
      render: printDateTime
    },
    ...(isRootUser ? [{
      name: 'partner',
      label: 'PARTNER',
      render: (value) => toTitleCase(value?.name ?? '')
    }] : []),
    {
      name: 'name',
      label: 'NAME',
      render: (value, rec: any) => (
          <Box
              sx={{
                alignItems: 'center',
                display: 'flex'
              }}
          >
            <ContactLink
                name={trimString(toTitleCase(value ?? ''), 20, '...')}
                id={rec.id}
                path={localRoutes.onboardingTemplates}
            />
          </Box>
      )
    },
    {
      name: 'description',
      label: 'DESCRIPTION',
      render: (value) => (
          <Box>
            <Typography
                variant="body2"
            >
              {trimString(toTitleCase(value ?? ''), 20, '...')}
            </Typography>
          </Box>
      )
    },
    {
      name: 'isActive',
      label: 'STATUS',
      render: (value) => (
          <Chip
              icon={value ? <CheckIcon color="success"/> : <CloseIcon color="error"/>}
              variant="filled"
              size="small"
              label={value ? 'Activated' : 'Deactivated'}
              sx={{ mr: 1 }}
          />
      )
    },
    {
      name: 'requestedByData',
      label: 'CREATED BY',
      render: (value) => toTitleCase(value?.name ?? '')
    },

  ];
};

export const filterFields: IColumn[] = [
  {
    name: 'from',
    label: 'From',
    inputProps: {
      inputType: InputType.Date,
      defaultValue: null,
      gridProps: {
        md: 3,
        xs: 12
      }
    },
  },
  {
    name: 'to',
    label: 'To',
    inputProps: {
      inputType: InputType.Date,
      defaultValue: null,
      gridProps: {
        md: 3,
        xs: 12
      }
    },
  },
  {
    name: 'IsActive',
    label: 'Status',
    inputProps: {
      inputType: InputType.Select,
      options: ['true', 'false'],
      size: 'medium',
      gridProps: {
        md: 3,
        xs: 12
      }
    },
  }
];

export const renderPhoneRequestStatus = (value: RequestStatus) => {
  let icon: any;

  switch (value) {
    case RequestStatus.Completed: {
      icon = <CheckIcon color="success"/>;
      break;
    }
    case RequestStatus.Processing:
      icon = <LoopIcon color="primary"/>;
      break;
    case RequestStatus.Failed:
      icon = <CloseIcon color="error"/>;
      break;
    default:
      icon = <PendingIcon color="disabled"/>;
      break;
  }

  return (
      <Chip
          icon={icon}
          variant="filled"
          size="small"
          label={value}
      />
  );
};

export enum OnboardingDataType {
  Image = 'IMAGE',
  Text = 'TEXT',
  Phone = 'PHONE',
  Email = 'EMAIL',
  Number = 'NUMBER',
}

export enum OnboardingPersonIdDocumentCategory {
  NationalId = 'NationalId'
}

export interface OnboardingIdDocument {
  category: OnboardingPersonIdDocumentCategory;
  dataType: OnboardingDataType;
  shouldCapture: boolean;
  isVerifiable: boolean;
  shouldVerify: boolean;
  isRequired: boolean;
}

export enum OnboardingBiometricCategory {
  Face = 'Face',
}

export interface OnboardingBiometric {
  category: OnboardingBiometricCategory;
  dataType: OnboardingDataType;
  shouldCapture: boolean;
  isVerifiable: boolean;
  shouldVerify: boolean;
  isRequired: boolean;
}

export enum OnboardingContactCategory {
  Phone = 'Phone',
  Email = 'Email',
  PhysicalAddress = 'PhysicalAddress',
}

export interface OnboardingContact {
  category: OnboardingContactCategory;
  dataType: OnboardingDataType;
  shouldCapture: boolean;
  isVerifiable: boolean;
  shouldVerify: boolean;
  isRequired: boolean;
}

export enum OnboardingFinancialAccountCategory {
  MobileMoney = 'MobileMoney',
  BankAccount = 'BankAccount',
}

export interface OnboardingFinancialAccount {
  category: OnboardingFinancialAccountCategory;
  dataType: OnboardingDataType;
  shouldCapture: boolean;
  isVerifiable: boolean;
  shouldVerify: boolean;
  isRequired: boolean;
}

